<template>
  <SoDialog
    ref="install-codes-details-modal"
    v-model="isOpen"
    class="install-codes-modal"
  >
    <InstallCodesRequestEmails :install-code-row="installCodeRow" />

    <div v-if="!installCodeRow.installCode" class="my-10">
      <v-icon icon="close" size="large" color="error"></v-icon>
      Install Code Missing. Action required.
    </div>
    <InstallCodesAsnMessage
      v-else
      :install-code-row="installCodeRow"
      class="my-10"
    />

    <div class="d-flex align-center justify-space-between mb-4">
      <h5>Overview</h5>
    </div>
    <SoSimpleTable
      ref="overview-table"
      :headers="Object.keys(overviewDetails)"
      :items="[Object.values(overviewDetails)]"
      is-pivoted
      equal-width-columns
    />
  </SoDialog>
</template>

<script lang="ts">
  import { PropType, defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import { formatDate } from "@/helpers/dateHelper"
  import { IInstallCode } from "@/models/installCode/installCode.types"
  import InstallCodesAsnMessage from "./InstallCodesAsnMessage.vue"
  import InstallCodesRequestEmails from "./InstallCodesRequestEmails.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoSimpleTable,
      InstallCodesAsnMessage,
      InstallCodesRequestEmails,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      installCodeRow: {
        type: Object as PropType<IInstallCode>,
        default: () => ({}),
        required: false,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      overviewDetails() {
        return {
          MPXN: this.installCodeRow.mpxn || "-",
          MSN: this.installCodeRow.msn || "-",
          "Install Code": this.installCodeRow.installCode || "-",
          Comment: this.installCodeRow.comment || "-",
          "Device Id": this.installCodeRow.deviceId || "-",
          "ASN outcome": this.installCodeRow.asnOutcome || "-",
          "ASN submitted date": formatDate(this.installCodeRow.asnDate) || "-",
          "Requested date":
            formatDate(this.installCodeRow.requestedDate) || "-",
          "Last date checked":
            formatDate(this.installCodeRow.lastDateChecked) || "-",
          "Map id": this.installCodeRow.mapId || "-",
          "Map name": this.installCodeRow.mapName || "-",
        }
      },
      isOpen: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>

<style scoped>
  .install-codes-modal__text-layout-grid {
    display: grid;
    grid-template-columns: 2fr 2fr;
    gap: 16px;
  }
</style>
